"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Elements = require("../../../../Elements");

var _Elements2 = require("./Elements");

var _helpers = require("../../../../common/helpers");

var About = function About(_ref) {
  var cover = _ref.cover,
      description = _ref.description,
      location = _ref.location;
  var descriptionElements = (0, _helpers.generateParagraphs)({
    description: description,
    isDesktopSmall: false
  });
  return /*#__PURE__*/_react["default"].createElement(_Elements2.AboutBox, {
    flex: true,
    align: "center",
    justify: "center",
    column: true
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioHeadingMedium, {
    portfolioForeground1: true,
    normal: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.about"
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.AboutCoverBox, {
    my: "md"
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.AboutCover, {
    src: cover
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.AboutDescription, null, descriptionElements), location && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: true,
    bold: true,
    portfolioForeground2: true,
    mb: "xs",
    mt: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.message.caption.location"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true
  }, location)));
};

About.defaultProps = {
  cover: '',
  location: ''
};
About.propTypes = {
  cover: _propTypes["default"].string,
  description: _propTypes["default"].string.isRequired,
  location: _propTypes["default"].string
};
var _default = About;
exports["default"] = _default;